var CanvasPictureHelper;
(function (CanvasPictureHelper) {
    var Controller = (function () {
        function Controller(canvasElementId) {
            this.canvasElementId = canvasElementId.toString();
            this.IsEmptyPicture = true;
            this.imageX = 0;
            this.imageY = 0;
            this.imageWidth = 100;
            this.imageHeight = 100;
            this.imageWidthRatio = 100;
            this.imageHeightRatio = 100;
            this.imageRight = 0;
            this.imageBottom = 0;
            this.startX = 0;
            this.startY = 0;
            this.draggingImage = false;
            this.canvas = document.getElementById(this.canvasElementId);
            if (!this.canvas)
                return;
            this.context = this.canvas.getContext("2d");
            this.imageObj = new Image();
            this.canvasOffset = $("#" + this.canvasElementId).offset();
            this.offsetX = this.canvasOffset.left;
            this.offsetY = this.canvasOffset.top;
            this.imageSrc = null;

            var _this = this;
        }

        Controller.prototype.OnLoadImageLoadEvent = function () {
            var _this = this;
            var def = $.Deferred();

            _this.imageObj.onload = function () {
                if (_this.imageObj.width >= _this.imageObj.height) {
                    _this.imageHeightRatio = 100;
                    _this.imageWidthRatio = (_this.imageObj.width / _this.imageObj.height) * _this.imageHeightRatio;
                } else {
                    _this.imageWidthRatio = 100;
                    _this.imageHeightRatio = (_this.imageObj.height / _this.imageObj.width) * _this.imageWidthRatio;
                }
                _this.imageX = 0;
                _this.imageY = 0;
                _this.imageWidth = _this.imageObj.width;
                _this.imageHeight = _this.imageObj.height;
                _this.imageRight = _this.imageX + _this.imageWidth;
                _this.imageBottom = _this.imageY + _this.imageHeight;
                _this.draw();
                _this.canvasOffset = $("#" + _this.canvasElementId).offset();
                _this.offsetX = _this.canvasOffset.left;
                _this.offsetY = _this.canvasOffset.top;
                def.resolve();
            };
            return def.promise();
        };

        Controller.prototype.FetchImgBase64String = function () {
            let _canvas = document.createElement('canvas');
            let _context = _canvas.getContext("2d");
            let _orgImage = new Image();
            _orgImage.src = this.imageSrc;

            let min_length = Math.min(_orgImage.height, _orgImage.width);

            _canvas.height = _orgImage.height;
            _canvas.width = _orgImage.width;

            let _scaling = min_length / 100; // scaling for 100x100px canvas for moving offset

            let destWidth = _canvas.width * (this.imageWidthRatio / 100);
            let destHeight = _canvas.height * (this.imageHeightRatio / 100);
            let destX = this.imageX * _scaling / (_orgImage.width / destWidth);
            let destY = this.imageY * _scaling / (_orgImage.height / destHeight);

            _context.drawImage(_orgImage, 0, 0, _orgImage.width, _orgImage.height, destX, destY, destWidth, destHeight);
            return _canvas.toDataURL();
        };


        Controller.prototype.hitImage = function (x, y) {
            var _this = this;
            return (x > _this.imageX && x < _this.imageX + _this.imageWidth && y > _this.imageY && y < _this.imageY + _this.imageHeight);
        };

        Controller.prototype.handleMouseUp = function (e) {
            var _this = this;
            _this.draggingImage = false;
            _this.draw(true, false);
        };

        Controller.prototype.handleMouseOut = function (e) {
            var _this = this;
            _this.handleMouseUp(e);
        };

        Controller.prototype.handleMouseDown = function (e) {
            var _this = this;
            _this.startX = parseInt(e.clientX - _this.offsetX);
            _this.startY = parseInt(e.clientY - _this.offsetY);
            _this.draggingImage = _this.hitImage(_this.startX, _this.startY);
        };

        Controller.prototype.handleMouseMove = function (e) {
            var _this = this;
            if (_this.draggingImage) {
                var mouseX = parseInt(e.clientX - _this.offsetX);
                var mouseY = parseInt(e.clientY - _this.offsetY);
                var dx = mouseX - _this.startX;
                var dy = mouseY - _this.startY;
                _this.imageX += dx;
                _this.imageY += dy;

                if (_this.imageX > 0)
                    _this.imageX = 0;
                if (_this.imageX < -_this.imageWidthRatio + 100)
                    _this.imageX = -_this.imageWidthRatio + 100;

                if (_this.imageY > 0)
                    _this.imageY = 0;
                if (_this.imageY < -_this.imageHeightRatio + 100)
                    _this.imageY = -_this.imageHeightRatio + 100;

                _this.imageRight += dx;
                _this.imageBottom += dy;
                _this.startX = mouseX;
                _this.startY = mouseY;
                _this.draw(false, true);
            }
        };

        Controller.prototype.draw = function () {
            var _this = this;
            if ($(_this.imageObj).attr("src") === "")
                return;
            _this.context.clearRect(0, 0, _this.canvas.width, _this.canvas.height);


            _this.context.drawImage(_this.imageObj, 0, 0, _this.imageObj.width, _this.imageObj.height, _this.imageX, _this.imageY, _this.imageWidthRatio, _this.imageHeightRatio);
            _this.IsEmptyPicture = false;
        };

        Controller.prototype.ResetCanvas = function () {
            var _this = this;
            $(_this.imageObj).attr("src", "/Style/Images/gb_no_profile_pic_100x100.png");
            _this.context.clearRect(0, 0, _this.canvas.width, _this.canvas.height);
            _this.IsEmptyPicture = true;
        };

        return Controller;
    })();
    CanvasPictureHelper.Controller = Controller;
})(CanvasPictureHelper || (CanvasPictureHelper = {}));